import type { MatchPhase, ProjectState } from "@livcg/schema";
import { sendRaw } from "../../shared/sendRaw.js";
import { cn, focusRing } from "../../ui/index.js";
import { PHASE_LABEL, PHASE_SHORT, PHASES } from "../phases.js";
import { Panel } from "./Panel.js";

type Props = { slug: string; state: ProjectState };

/** Direct-jump phase selector. `clock.setPhase` resets the clock to the
 *  phase start server-side, so this doubles as the "advance the match"
 *  control. The full label of the active phase is shown above the grid. */
export function PhaseNavigator({ slug, state }: Props) {
  const current = state.match.phase;
  const setPhase = (phase: MatchPhase) => void sendRaw("clock.setPhase", { slug, phase });

  return (
    <Panel
      label="Bosqich"
      action={<span className="text-[11px] text-ink-soft">{PHASE_LABEL[current]}</span>}
    >
      <div role="radiogroup" className="grid grid-cols-3 gap-1">
        {PHASES.map((p) => {
          const active = p === current;
          return (
            <button
              key={p}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => setPhase(p)}
              title={PHASE_LABEL[p]}
              className={cn(
                focusRing,
                "h-8 rounded-md border font-mono text-[11px] font-medium transition-colors",
                active
                  ? "border-accent-strong/50 bg-accent/15 text-accent-strong"
                  : "border-border bg-surface text-ink-muted hover:bg-surface-elevated hover:text-ink",
              )}
            >
              {PHASE_SHORT[p]}
            </button>
          );
        })}
      </div>
    </Panel>
  );
}
